import React from 'react';
import TaxPenaltyGuide from '../../../components/ui/TaxPenaltyGuide.jsx';

export default function TaxGuidePage() {
  return (
    <div className="max-w-2xl mx-auto space-y-5">
      {/* Hero card */}
      <div className="card overflow-hidden flex">
        <div className="w-1 bg-accent flex-shrink-0" />
        <div className="p-5 flex-1">
          <h1 className="text-[20px] font-bold text-text leading-tight">Tax &amp; Penalty Guide</h1>
          <p className="text-sm text-text-muted mt-1 leading-relaxed">
            See exactly how each transaction type affects your account, how much the IRS withholds upfront,
            and any penalties you may owe at tax time. Enter any amount to recalculate live.
          </p>
        </div>
      </div>

      <TaxPenaltyGuide />
    </div>
  );
}
